export interface ProductCategoryPayloadOptions {
  company: string;
  branch: string;
}

/** Body for PATCH .../branches/:branchId/products/product-categories/:id (UpdateCategoryDto). */
export function buildProductCategoryUpdatePayload(
  category: object,
  options: ProductCategoryPayloadOptions,
): Record<string, unknown> {
  const c = (category || {}) as Record<string, unknown>;
  const payload: Record<string, unknown> = {
    company: options.company,
    branch: options.branch,
  };

  if (c.name) payload.name = String(c.name);
  if (c.description !== undefined && c.description !== null) {
    payload.description = String(c.description);
  }

  return payload;
}

/** Body for POST .../branches/:branchId/products/product-categories (CreateCategoryDto). */
export function buildProductCategoryCreatePayload(
  category: object,
  options: ProductCategoryPayloadOptions,
): Record<string, unknown> {
  return buildProductCategoryUpdatePayload(category, options);
}
